export enum ListingStatus {
    PremiumReview = 'Premium Review',
    PremiumReviewBPMSubmitted = 'Premium Review - BPM Submitted',
    PremiumMasterSpecReview = 'Premium MasterSpec Review',
    PremiumMasterSpecReviewBPMSubmitted = 'Premium MasterSpec Review - BPM Submitted',
    InReview = 'In Review',
    BPMSubmitted = 'BPM Submitted',
    ProprietaryReview = 'Proprietary Review',
    ProprietaryReviewBPMSubmitted = 'Proprietary Review - BPM Submitted',
    Completed = 'Completed',
}
